/* eslint-disable no-nested-ternary */
import './index.scss'

import React, { forwardRef, ReactNode } from 'react'
import BEMHelper from 'react-bem-helper'
import { Link } from 'react-router-dom'
import { LoadingIndicator } from 'components/Spinner'
import Icon, { Props as IconProps } from 'components/Icon'

const bem = new BEMHelper('button')

export type Props = {
  children?: ReactNode
  label?: string
  hiddenLabel?: string
  icon?: IconProps['icon']
  href?: string
  primary?: boolean
  shade?: boolean
  muted?: boolean
  warning?: boolean
  full?: boolean
  arrow?: boolean
  small?: boolean
  xsmall?: boolean
  spaceless?: boolean
  circle?: boolean
  rounded?: boolean
  disabled?: boolean
  inline?: boolean
  selected?: boolean
  dark?: boolean
  noMargin?: boolean
  large?: boolean
  plain?: boolean
  link?: boolean
  loading?: boolean
  className?: string
  to?: string
  type?: string
  style?: object
  count?: string | number
  iconProps?: {
    [key: string]: any
    direction?: IconProps['direction']
    title?: string
  }
  onClick?: () => void
}

const Button = forwardRef<HTMLButtonElement, Props>(
  (
    {
      children,
      label,
      hiddenLabel,
      primary = false,
      shade = false,
      muted = false,
      warning = false,
      full = false,
      arrow = false,
      small = false,
      xsmall = false,
      spaceless = false,
      circle = false,
      rounded = false,
      disabled = false,
      inline = false,
      selected = false,
      dark = false,
      noMargin = false,
      large = false,
      plain = false,
      link = false,
      loading = false,
      className,
      to,
      href,
      icon = null,
      count = null,
      iconProps,
      ...props
    },
    ref,
  ) => {
    const Node = href ? 'a' : to ? Link : 'button'
    const extraProps = href ? { href } : to ? { to } : { type: 'button' }

    const modifiers = {
      primary,
      muted,
      shade,
      warning,
      full,
      spaceless,
      arrow,
      icon: Boolean(icon),
      circle,
      small,
      xsmall,
      disabled,
      inline,
      selected,
      dark,
      large,
      plain,
      rounded,
      link,
      loading,
      'no-margin': noMargin,
    }

    return (
      <Node
        {...bem('', modifiers, className)}
        disabled={disabled}
        aria-label={hiddenLabel}
        {...(extraProps as any)}
        {...props}
        ref={ref as any}
        aria-pressed={selected}
      >
        {icon != null ? <Icon icon={icon} {...iconProps} {...bem('icon')} /> : null}
        {(label || children) && <span {...bem('label')}>{label ?? children}</span>}
        {arrow && !loading && <Icon icon="chevron" {...bem('arrow')} />}
        {count != null && <span {...bem('count')}>{count}</span>}
        {loading && <LoadingIndicator width={24} box={false} {...bem('loading-indicator')} />}
      </Node>
    )
  },
)

export default Button
